import {
  fontSizes,
  lineHeights,
  screenBreakpoints,
  shadows,
  spacings,
} from "@unlikelyai-magic/ui/variables";

export const theme = {
  colors: {
    background: {
      default: "#ffffff", // White background
      1: "#f7f7f7", // Light grey
      2: "#e6e6e6", // Slightly darker grey
    },
    component: {
      background: {
        default: "#11b67a", // Lloyds Bank green
        1: "#f7f7f7", // Light grey
        2: "#e6e6e6", // Slightly darker grey
        3: "#d0d0d0", // Medium grey
        dark: {
          2: "#003B23", // Darker green
        },
      },
      border: {
        1: "#e6e6e6", // Grey border
        2: "#d0d0d0", // Medium grey border
        dark: "#003B23", // Dark green border
      },
    },
    text: {
      primary: {
        default: "#004B2D", // Lloyds Bank green
      },
      secondary: {
        default: "#6e6b6f", // Neutral grey
      },
      dark: {
        default: "#ffffff", // White text for dark backgrounds
      },
    },
    action: {
      primary: {
        2: {
          default: "#004B2D", // Lloyds Bank green
          hover: "#006B3F", // Slightly lighter green
          clicked: "#003B23", // Darker green
          inactive: "#b6bfb4", // Muted grey-green
        },
        default: "#004B2D", // Lloyds Bank green
        hover: "#006B3F", // Slightly lighter green
        clicked: "#003B23", // Darker green
        inactive: "#b6bfb4", // Muted grey-green
      },
      secondary: {
        default: "#ffffff00", // Transparent
        hover: "#d0d0d0", // Medium grey
        clicked: "#e6e6e6", // Light grey
      },
      warning: {
        default: "#da0101", // Red for warnings
        hover: "#af0000", // Darker red
        clicked: "#c50000", // Slightly muted red
        inactive: "#f4b2b2", // Muted red
      },
      link: {
        default: "#004B2D", // Lloyds Bank green for links
      },
      dark: {
        default: "#004B2D", // Lloyds Bank green
        hover: "#006B3F", // Slightly lighter green
        clicked: "#003B23", // Darker green
        inactive: "#b6bfb4", // Muted grey-green
      },
    },
    semantic: {
      success: {
        default: "#004B2D", // Lloyds Bank green
        background: "#e5edea", // Light green background
      },
      warning: {
        default: "#e6902d", // Orange for warnings
        background: "#fcf3ea", // Light orange background
      },
      error: {
        default: "#da0101", // Red for errors
        background: "#fbe5e5", // Light red background
      },
    },
  },
  roundness: {
    xs: "0.25rem", // 4px
    sm: "0.5rem", // 8px
    md: "0.75rem", // 12px
    lg: "1rem", // 16px
    xl: "1.5rem", // 24px
    "2xl": "2rem", // 32px
    "3xl": "2.5rem", // 40px
    "4xl": "3rem", // 48px
    "5xl": "3.5rem", // 56px
  },
  spacings,
  lineHeights,
  fontSizes,
  screenBreakpoints,
  shadows,
};
